import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { RequireNoAuth } from '../middlewares/HOC';
import PATHS from './PATHS';

import { PublicBadgeRelease, PublicCertAttendRelease } from '../pages';
import * as V2 from './landingScreens';

const LandingStack = () => {
    return <Switch>
        <Route path={PATHS.LANDING_HOME.URL} exact component={V2.Home} />
        <Route path={PATHS.LANDING_CERTIFICATIONS.URL} exact component={V2.Catalogue} />
        <Route path={PATHS.LANDING_CERTIFICATIONS_DETAILS.URL} exact component={V2.CertificateDetails} />
        <Route path={PATHS.LANDING_CONTACTUS.URL} exact component={V2.ContactUs} />
        <Route path={PATHS.LANDING_TERMS_AND_CONDITIONS.URL} exact component={V2.TermsAndConditions} />
        <Route path={PATHS.LANDING_PRIVACY_POLICY.URL} exact component={V2.PrivacyPolicy} />
        <Route path={PATHS.LANDING_BADGES.URL} exact component={PublicBadgeRelease} />
        <Route path={PATHS.LANDING_CERT_ATTENDANCE.URL} exact component={PublicCertAttendRelease} />

        <Route path={PATHS.LANDING_RESET_PASSWORD.URL} exact component={V2.ResetPassword} />
        <Route path={PATHS.LANDING_ACTIVATION.URL} exact component={V2.Activation} />
        <Route path={PATHS.LANDING_SIGNUP.URL} exact component={RequireNoAuth(V2.Signup)} />
        <Route path={PATHS.LANDING_SIGNIN.URL} exact component={RequireNoAuth(V2.Signin)} />
        <Route path={PATHS.LANDING_FORGOT_PASSWORD.URL} exact component={RequireNoAuth(V2.ForgotPassword)} />
        <Route path={PATHS.LANDING_CHECK_EMAIL.URL} exact component={RequireNoAuth(V2.CheckEmail)} />
        <Route path={PATHS.USER_FREQ_EXAM.URL} exact component={V2.Signin} />

        {/* Invalid Routes */}
        <Route>
            <Route path="*" exact component={V2.Home} />
            <Redirect from='*' to={PATHS.LANDING_HOME.URL} />
        </Route>

    </Switch>;
};

export default React.memo(LandingStack);
